/* kb-search.js: zoekoverlay (B5) en resultatenpagina (B6) op de eigen zoek-API, met terugval op Shopify's zoekpagina.
   Vereist window.KBREC (kb-config), de kaart-template (kbr-card) en het overlay-snippet. */
(function () {
  'use strict';
  var C = window.KBREC;
  if (!C || !C.api) return;
  var S = C.strings.search || {};
  var t = function (k, d) { return S[k] || d; };
  var TIMEOUT = 800;

  function fetchJson(url, ms) {
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var tm = setTimeout(function () { if (ctrl) ctrl.abort(); }, ms || TIMEOUT);
    return fetch(url, { signal: ctrl ? ctrl.signal : undefined, mode: 'cors' }).then(function (r) { clearTimeout(tm); if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function money(n) { var s = Number(n).toFixed(2).replace('.', ','); var f = (C.money && C.money.format) || '€{{amount}}'; return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function prefix() { return C.localePrefix === '/' ? '' : (C.localePrefix || ''); }
  function visitor() { return window.KBTrack ? window.KBTrack.visitor() : null; }
  function track(ev) { if (window.KBTrack) window.KBTrack.track(ev); }
  // settings.kb_search_view = 'kb' zolang search.json nog de oude resultatenpagina is (vergelijkperiode): dan via het
  // alternatieve template search.kb. Leeg zodra de KB-resultatenpagina het standaardtemplate is.
  function searchUrl(q, extra) { return prefix() + '/search?q=' + encodeURIComponent(q) + (C.searchView ? '&view=' + encodeURIComponent(C.searchView) : '') + (extra || ''); }

  /* Kaart uit de template, met zoek-klik-tracking. */
  function card(p, q, position) {
    var tpl = document.getElementById('kbr-card-template');
    var node = window.KBRecs.fill(tpl.content.cloneNode(true), p);
    node.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { track({ type: 'search_click', query: q, product_id: p.id, position: position }); if (window.KBTrack) window.KBTrack.flush(); });
    });
    var a0 = node.querySelector('.kbr-card__link');
    node.querySelector('.kbr-card__add').addEventListener('click', function () { a0.click(); });
    return node;
  }

  /* ---------- overlay ---------- */
  var ov = document.getElementById('kb-search');
  if (ov) initOverlay(ov);

  function initOverlay(ov) {
    var input = ov.querySelector('.kb-search__input');
    var wipe = ov.querySelector('[data-kb="wipe"]');
    var q = function (k) { return ov.querySelector('[data-kb="' + k + '"]'); };
    var timer = null, seq = 0, scope = '', initial = null;

    // open(term): met een zoekterm (bijvoorbeeld uit een chip /search?q=...) staat die direct in het veld en zoekt de overlay meteen.
    function open(term) {
      ov.hidden = false; document.body.classList.add('kb-search-open');
      if (typeof term === 'string' && term.trim()) { input.value = term.trim(); wipe.hidden = false; }
      setTimeout(function () { input.focus(); }, 30);
      if (input.value.trim().length >= 2) onType(); else loadInitial();
    }
    function close() { ov.hidden = true; document.body.classList.remove('kb-search-open'); }
    window.KBSearch = { open: open, close: close };
    ov.querySelector('.kb-search__close').addEventListener('click', close);
    q('backdrop').addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) close(); });
    // Openen vanuit het standaard zoekformulier van Blockshop.
    document.querySelectorAll('form[action*="/search"] input[name="q"]').forEach(function (el) {
      if (ov.contains(el)) return;
      el.addEventListener('focus', function (e) { e.preventDefault(); open(); });
    });
    // Openen via klik (gedelegeerd, dus ook voor knoppen en chips die later in de pagina komen):
    // data-kb-search-open / data-kb-open-search (knop "Search" op de homepage), of een link naar /search.
    // Een link met ?q= neemt de zoekterm mee; data-kb-search-term wint als die er staat.
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var el = e.target.closest && e.target.closest('[data-kb-search-open], [data-kb-open-search], a[href*="/search"]');
      if (!el || ov.contains(el)) return;
      var resultsPage = document.querySelector('[data-kb-search-results]');
      if (resultsPage && resultsPage.contains(el)) return;
      var term = el.getAttribute('data-kb-search-term') || '';
      if (el.tagName === 'A') {
        var u; try { u = new URL(el.href, location.href); } catch (err) { return; }
        if (u.origin !== location.origin || !/\/search\/?$/.test(u.pathname)) return;
        if (!term) term = u.searchParams.get('q') || '';
      }
      e.preventDefault(); open(term);
    });
    // Blockshop: het zoekicoon is een knop die de top-drawer opent (data-drawer-view="search"). In de capture-fase
    // onderscheppen, zodat de drawer van het theme niet ook opengaat.
    window.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.header--search, [data-drawer-open][data-drawer-view="search"]');
      if (!b || ov.contains(b)) return;
      e.preventDefault(); e.stopPropagation(); open();
    }, true);
    if (location.hash === '#zoeken') open();

    function show(state) { ov.querySelectorAll('.kb-search__state').forEach(function (el) { el.hidden = el.getAttribute('data-state') !== state; }); }
    function setQuery(v) { input.value = v; wipe.hidden = !v; onType(); input.focus(); }

    /* Scope-chips: Alles, Merken, Ingrediënten, Huidbehoefte. */
    q('scopes').querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        scope = b.getAttribute('data-scope') || '';
        q('scopes').querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        if (input.value.trim().length >= 2) onType(); else input.focus();
      });
    });
    wipe.addEventListener('click', function () { setQuery(''); });

    function chips(box, terms, icon) {
      box.innerHTML = (terms || []).slice(0, 8).map(function (p) { return '<button type="button">' + (icon ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 17l6-6 4 4 8-8M14 7h7v7"/></svg>' : '') + esc(p) + '</button>'; }).join('');
      box.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { setQuery(b.textContent.trim()); }); });
    }
    function img(p, w) { return p.image ? '<img src="' + esc(window.KBRecs.sized(p.image, w)) + '" alt="" loading="lazy">' : ''; }
    function rating(p) { return p.rating ? '★ ' + String(Number(p.rating).toFixed(1)).replace('.', ',') : ''; }

    function loadInitial() {
      show('empty');
      if (initial) return;
      initial = fetchJson(C.api + '/search/suggest?locale=' + C.locale).then(function (d) {
        chips(q('popular'), d.popular, true);
        chips(q('popular-none'), d.popular, false);
        q('trending').innerHTML = (d.trending || []).slice(0, 3).map(function (p, i) {
          return '<li><a class="kb-search__mini" href="' + esc(p.url) + '" data-id="' + p.id + '"><span class="kb-search__mini-media">' + img(p, 300) + '<span class="kb-search__rank">#' + (i + 1) + '</span></span>' +
            '<span class="kb-search__brand">' + esc(p.vendor || '') + '</span><span class="kb-search__mini-name">' + esc(p.title) + '</span>' +
            '<span class="kb-search__mini-foot"><b>' + money(p.price) + '</b><span>' + rating(p) + '</span></span></a></li>';
        }).join('');
        q('trending').querySelectorAll('a').forEach(function (a, i) { a.addEventListener('click', function () { track({ type: 'search_click', query: '', product_id: +a.getAttribute('data-id'), position: i + 1, extra: { source: 'overlay_trending' } }); }); });
        q('empty-products').innerHTML = (d.bestsellers || d.trending || []).slice(0, 4).map(function (p) {
          return '<li><a href="' + esc(p.url) + '"><span class="kb-search__best-media">' + img(p, 300) + '</span><b>' + esc(p.title) + '</b><span>' + money(p.price) + '</span></a></li>';
        }).join('');
        return d;
      }).catch(function () { initial = null; });
      loadRecent();
    }
    function loadRecent() {
      var vis = visitor(), box = q('recent-box');
      var cleared = false; try { cleared = localStorage.getItem('kb_recent_cleared') === '1'; } catch (e) {}
      if (!vis || cleared) { box.hidden = true; return; }
      fetchJson(C.api + '/recs?placement=home_recent&locale=' + C.locale + '&visitor=' + vis + '&limit=3').then(function (r) {
        var items = (r.products || []).slice(0, 3);
        box.hidden = !items.length;
        q('recent').innerHTML = items.map(function (p) {
          return '<li><a class="kb-search__row-a" href="' + esc(p.url) + '"><span class="kb-search__thumb">' + img(p, 120) + '</span><span class="kb-search__meta"><span class="kb-search__brand">' + esc(p.vendor || '') + '</span><span class="kb-search__name">' + esc(p.title) + '</span></span><span class="kb-search__price">' + money(p.price) + '</span></a></li>';
        }).join('');
      }).catch(function () { box.hidden = true; });
    }
    q('recent-clear').addEventListener('click', function () {
      try { localStorage.setItem('kb_recent_cleared', '1'); localStorage.removeItem('kb_recent'); } catch (e) {}
      q('recent-box').hidden = true;
    });

    input.addEventListener('input', function () { wipe.hidden = !input.value; clearTimeout(timer); timer = setTimeout(onType, 150); });
    input.form.addEventListener('submit', function (e) {
      var v = input.value.trim();
      if (!v) { e.preventDefault(); return; }
      track({ type: 'search', query: v, results_count: null, extra: { source: 'overlay_submit' } });
    });

    var hasResults = false;
    function onType() {
      var v = input.value.trim();
      if (v.length < 2) { loadInitial(); return; }
      var my = ++seq;
      var slow = setTimeout(function () { if (my === seq && !hasResults) show('loading'); }, 120);
      fetchJson(C.api + '/search/suggest?q=' + encodeURIComponent(v) + '&locale=' + C.locale + (scope ? '&scope=' + scope : '')).then(function (d) {
        clearTimeout(slow);
        if (my !== seq) return;
        if (!d.total) return onEmpty(v, my);
        show('typing'); hasResults = true;
        var lv = v.toLowerCase();
        var hl = function (s) { var i = s.toLowerCase().indexOf(lv); return i < 0 ? esc(s) : esc(s.slice(0, i)) + '<b>' + esc(s.slice(i, i + v.length)) + '</b>' + esc(s.slice(i + v.length)); };
        // Suggesties: zoektermen, dan productnamen (met merk als soort).
        var sugg = (d.terms || []).slice(0, 4).map(function (x) { return '<a href="' + searchUrl(x) + '" data-term="' + esc(x) + '">' + hl(x) + '<small>' + esc(t('term', 'Zoekterm')) + '</small></a>'; })
          .concat((d.products || []).slice(0, 3).map(function (p) { return '<a href="' + esc(p.url) + '">' + hl(p.title) + '<small>' + esc(p.vendor || '') + '</small></a>'; }))
          .slice(0, 6);
        q('terms').innerHTML = sugg.join('');
        q('terms').querySelectorAll('a[data-term]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); setQuery(a.getAttribute('data-term')); }); });
        var cats = (d.categories || []).concat(d.vendors || []);
        q('cats-box').hidden = !cats.length;
        q('categories').className = 'kb-search__sugg kb-search__sugg--cats';
        q('categories').innerHTML = cats.map(function (x) { return '<a href="' + esc(x.url) + '"><span>' + esc(x.title) + '</span>' + (x.count ? '<small>' + x.count + ' ' + esc(t('products', 'producten')) + '</small>' : '') + '</a>'; }).join('');
        q('articles').innerHTML = (d.articles || []).length ? '<section><h3>' + esc(t('articles', 'Artikelen')) + '</h3><div class="kb-search__sugg">' + d.articles.map(function (x) { return '<a href="' + esc(x.url) + '">' + hl(x.title) + '</a>'; }).join('') + '</div></section>' : '';
        var note = q('note');
        var corrected = d.products.length && d.products[0]._formatted && !/<b>/.test(d.products[0]._formatted.title) && d.terms.length && d.terms[0] !== lv;
        note.hidden = !corrected;
        if (corrected) note.innerHTML = esc(t('results_for', 'Resultaten voor')) + ' <strong>' + esc(d.terms[0]) + '</strong>. <a href="' + searchUrl(v) + '">' + esc(t('search_instead', 'Zoeken op')) + ' ' + esc(v) + '</a>';
        var ul = q('products');
        ul.innerHTML = d.products.slice(0, 4).map(function (p, i) {
          var stock = p.available === false ? '' : p.low_stock ? '<span class="kb-search__stock kb-search__stock--low">● ' + esc(cardStr('low_stock', 'Bijna uitverkocht')) + '</span>' : '<span class="kb-search__stock">● ' + esc(cardStr('in_stock', 'Op voorraad')) + '</span>';
          return '<li><a class="kb-search__row-a" href="' + esc(p.url) + '" data-i="' + i + '"><span class="kb-search__thumb">' + img(p, 160) + '</span>' +
            '<span class="kb-search__meta"><span class="kb-search__brand">' + esc(p.vendor || '') + '</span><span class="kb-search__name">' + esc(p.title) + '</span>' +
            '<span class="kb-search__info">' + (p.rating ? '<span>' + rating(p) + (p.rating_count ? ' (' + p.rating_count + ')' : '') + '</span>' : '') + stock + '</span></span>' +
            '<span class="kb-search__end"><span class="kb-search__price">' + money(p.price) + '</span>' + (p.available === false ? '' : '<button type="button" class="kb-search__plus" data-i="' + i + '" aria-label="' + esc(cardStr('add', 'Toevoegen')) + '">+</button>') + '</span></a></li>';
        }).join('');
        ul.querySelectorAll('a[data-i]').forEach(function (a) { a.addEventListener('click', function () { var i = +a.getAttribute('data-i'); track({ type: 'search_click', query: v, product_id: d.products[i].id, position: i + 1 }); if (window.KBTrack) window.KBTrack.flush(); }); });
        ul.querySelectorAll('.kb-search__plus').forEach(function (b) {
          b.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            var p = d.products[+b.getAttribute('data-i')];
            track({ type: 'search_click', query: v, product_id: p.id, position: +b.getAttribute('data-i') + 1, extra: { action: 'add' } });
            b.disabled = true;
            addProduct(p).then(function () { b.textContent = '✓'; b.classList.add('is-done'); setTimeout(function () { b.textContent = '+'; b.classList.remove('is-done'); b.disabled = false; }, 2000); }).catch(function () { b.disabled = false; });
          });
        });
        var all = q('all'); all.href = searchUrl(v);
        all.textContent = t('all_results', 'Alle {n} resultaten voor “{q}”').replace('{n}', d.total).replace('{q}', v);
        track({ type: 'search', query: v, results_count: d.total, extra: { source: 'overlay', scope: scope || undefined } });
      }).catch(function () { clearTimeout(slow); if (my === seq && !hasResults) loadInitial(); });
    }

    function onEmpty(v, my) {
      fetchJson(C.api + '/search?q=' + encodeURIComponent(v) + '&locale=' + C.locale).then(function (d) {
        if (my !== seq) return;
        if (d.redirect) { location.href = d.redirect; return; }
        hasResults = false;
        show('none');
        if (!initial) loadInitial(), show('none');
        q('empty-title').textContent = t('none_title', 'Geen resultaten voor “{q}”').replace('{q}', v);
        var dym = q('dym');
        dym.hidden = !d.suggestion;
        if (d.suggestion) {
          dym.innerHTML = esc(t('did_you_mean', 'Bedoelde je')) + ' <a href="' + searchUrl(d.suggestion) + '">' + esc(d.suggestion) + '</a>?';
          dym.querySelector('a').addEventListener('click', function (e) { e.preventDefault(); setQuery(d.suggestion); });
        }
        if ((d.fallback || []).length) {
          q('empty-products').innerHTML = d.fallback.slice(0, 4).map(function (p) {
            return '<li><a href="' + esc(p.url) + '"><span class="kb-search__best-media">' + img(p, 300) + '</span><b>' + esc(p.title) + '</b><span>' + money(p.price) + '</span></a></li>';
          }).join('');
        }
        track({ type: 'search', query: v, results_count: 0, extra: { source: 'overlay' } });
      }).catch(function () {});
    }
    window.KBSearch = { open: open, close: close };
  }

  function cardStr(k, d) { return (C.strings && C.strings.card && C.strings.card[k]) || d; }
  /* Snel toevoegen vanuit de overlay: eerste beschikbare variant, via Blockshop als dat er is. */
  function addProduct(p) {
    return fetch(prefix() + '/products/' + p.handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (prod) {
      var v = (window.KBPickVariant || (function (prod) { var vs = (prod.variants || []).filter(function (x) { return x.available; }); vs.sort(function (a, b) { return (b.price || 0) - (a.price || 0); }); return vs[0]; }))(prod);
      if (!v) throw new Error('uitverkocht');
      var BS = window.customElements && customElements.get('cart-element');
      var body = { items: [{ id: v.id, quantity: 1 }] };
      if (BS && typeof BS.addItems === 'function' && BS.sections) { body.sections = BS.sections; return BS.addItems({ method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }, null); }
      return fetch(prefix() + '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(body) });
    }).then(function () {
      document.dispatchEvent(new CustomEvent('theme:cart:productAdded', { detail: { product_id: p.id, kb_placement: 'search_overlay', kb_request_id: null } }));
    });
  }

  /* ---------- resultatenpagina ---------- */
  var page = document.querySelector('[data-kb-search-results]');
  if (page) initResults(page);

  function initResults(el) {
    var params = new URLSearchParams(location.search);
    var query = (params.get('q') || '').trim();
    var state = { q: query, page: 1, sort: params.get('sort') || 'relevance', filters: {}, price: [params.get('price_min'), params.get('price_max')] };
    ['vendor', 'category', 'skin_type', 'skin_concern', 'ingredients'].forEach(function (f) { if (params.get(f)) state.filters[f] = params.get(f).split(','); });
    var $ = function (k) { return el.querySelector('[data-kb="' + k + '"]'); };
    var labels = { vendor: t('f_vendor', 'Merk'), category: t('f_category', 'Categorie'), skin_type: t('f_skin_type', 'Huidtype'), skin_concern: t('f_skin_concern', 'Huidprobleem'), ingredients: t('f_ingredient', 'Ingrediënt') };
    var hits = [];

    function url() {
      var u = new URLSearchParams({ q: state.q, locale: C.locale, page: String(state.page), sort: state.sort });
      Object.keys(state.filters).forEach(function (f) { if (state.filters[f].length) u.set(f, state.filters[f].join(',')); });
      if (state.price[0]) u.set('price_min', state.price[0]);
      if (state.price[1]) u.set('price_max', state.price[1]);
      if (visitor()) u.set('visitor', visitor());
      return C.api + '/search?' + u.toString();
    }
    function load(append) {
      el.classList.add('is-loading');
      fetchJson(url(), 2500).then(function (d) {
        if (d.redirect) { location.href = d.redirect; return; }
        el.classList.remove('is-loading');
        render(d, append);
        if (!append) track({ type: 'search', query: state.q, results_count: d.total, extra: { source: 'page', filters: Object.keys(state.filters).filter(function (f) { return state.filters[f].length; }).concat(state.price[0] || state.price[1] ? ['price'] : []), sort: state.sort !== 'relevance' ? state.sort : undefined } });
      }).catch(function () {
        // Terugval: de standaard Shopify-zoekresultaten staan al in de pagina (sectie rendert ze server-side, verborgen).
        el.classList.remove('is-loading');
        var fb = el.querySelector('[data-kb="shopify-fallback"]');
        if (fb) { fb.hidden = false; el.querySelector('[data-kb="engine"]').hidden = true; }
      });
    }
    var anyFilter = function () { return Object.keys(state.filters).some(function (f) { return state.filters[f].length; }) || !!(state.price[0] || state.price[1]); };
    function render(d, append) {
      var tt = $('title'); tt.textContent = (tt.getAttribute('data-template') || 'Resultaten voor “{q}”').replace('{q}', d.query);
      $('count').textContent = d.total + ' ' + t('products', 'producten');
      var ul = $('products');
      if (!append) { ul.innerHTML = ''; hits = []; }
      d.hits.forEach(function (p, i) { hits.push(p); ul.appendChild(card(p, d.query, hits.length)); });
      var more = $('more');
      more.hidden = hits.length >= d.total;
      more.textContent = t('show_more', 'Toon meer') + ' (' + hits.length + ' ' + t('of', 'van') + ' ' + d.total + ')';
      if (!append) renderFacets(d.facets, d.price);
      if (!append) renderContent(d.content || []);
      renderActive();
      // Geen treffers door filters: wis-knop. Geen treffers zonder filters: bedoelde je en populaire terugval.
      $('nofilter').hidden = !(d.total === 0 && anyFilter());
      $('empty').hidden = d.total > 0 || anyFilter();
      if (!d.total && !anyFilter()) {
        $('dym').innerHTML = d.suggestion ? esc(t('did_you_mean', 'Bedoelde je')) + ' <a href="' + searchUrl(d.suggestion) + '">' + esc(d.suggestion) + '</a>?' : '';
        var fu = $('fallback'); fu.innerHTML = ''; (d.fallback || []).forEach(function (p, i) { fu.appendChild(card(p, d.query, i + 1)); });
      }
      if (!append) also(d);
    }
    // Contentstrook: artikel of landingspagina waarvan de titel bij de zoekterm past, boven de producten.
    function renderContent(list) {
      var box = $('content'); if (!box) return;
      box.hidden = !list.length;
      box.innerHTML = list.map(function (x) {
        return '<a class="kb-results__article" href="' + esc(x.url) + '">' + (x.image ? '<img src="' + esc(window.KBRecs.sized(x.image, 300)) + '" alt="" loading="lazy">' : '') +
          '<span><small>' + esc(t(x.kind === 'article' ? 'article' : 'page', x.kind === 'article' ? 'Artikel' : 'Pagina')) + '</small><b>' + esc(x.title) + '</b>' + (x.excerpt ? '<em>' + esc(x.excerpt) + '</em>' : '') + '</span></a>';
      }).join('');
    }
    // "Misschien ook interessant": trending producten die niet in de resultaten staan.
    var alsoData = null;
    function also(d) {
      var box = $('also-box'); if (!box) return;
      var show = function (list) {
        var ids = hits.map(function (h) { return h.id; });
        var items = (list || []).filter(function (p) { return ids.indexOf(p.id) < 0; }).slice(0, 6);
        box.hidden = !items.length || !d.total;
        $('also').innerHTML = items.map(function (p) { return '<li><a href="' + esc(p.url) + '"><span class="kb-results__also-media">' + (p.image ? '<img src="' + esc(window.KBRecs.sized(p.image, 300)) + '" alt="" loading="lazy">' : '') + '</span><b>' + esc(p.title) + '</b><span>' + money(p.price) + '</span></a></li>'; }).join('');
      };
      if (alsoData) return show(alsoData);
      fetchJson(C.api + '/recs?placement=notfound_trending&locale=' + C.locale + '&limit=12', 1500).then(function (r) { alsoData = r.products || []; show(alsoData); }).catch(function () { box.hidden = true; });
    }
    var BUCKETS = [['', '20'], ['20', '30'], ['30', '']];
    function bucketLabel(b) { return b[0] && b[1] ? money(b[0]) + ' – ' + money(b[1]) : b[1] ? t('price_to', 'Tot') + ' ' + money(b[1]) : t('price_from', 'Vanaf') + ' ' + money(b[0]); }
    function renderFacets(facets) {
      var box = $('facets'); box.innerHTML = '';
      Object.keys(labels).forEach(function (f) {
        var opts = facets[f] || [];
        if (!opts.length) return;
        box.insertAdjacentHTML('beforeend', '<div class="kb-facet"><span class="kb-facet__label">' + esc(labels[f]) + '</span>' + opts.slice(0, 10).map(function (o) {
          var on = (state.filters[f] || []).indexOf(o.value) >= 0;
          return '<label><input type="checkbox" data-f="' + f + '" value="' + esc(o.value) + '"' + (on ? ' checked' : '') + '>' + esc(o.value) + '<span>' + o.count + '</span></label>';
        }).join('') + '</div>');
      });
      // Prijs als drie vaste schijven (zoals het ontwerp); meerdere aan = de omvattende range.
      box.insertAdjacentHTML('beforeend', '<div class="kb-facet"><span class="kb-facet__label">' + esc(t('f_price', 'Prijs')) + '</span>' + BUCKETS.map(function (b, i) {
        var on = (state.price[0] || '') === b[0] && (state.price[1] || '') === b[1];
        return '<label><input type="checkbox" data-price="' + i + '"' + (on ? ' checked' : '') + '>' + esc(bucketLabel(b)) + '</label>';
      }).join('') + '</div>');
      box.querySelectorAll('input[data-f]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          var f = cb.getAttribute('data-f'); state.filters[f] = state.filters[f] || [];
          if (cb.checked) state.filters[f].push(cb.value); else state.filters[f] = state.filters[f].filter(function (x) { return x !== cb.value; });
          state.page = 1; sync(); load(false);
        });
      });
      box.querySelectorAll('input[data-price]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          var sel = [].slice.call(box.querySelectorAll('input[data-price]')).filter(function (x) { return x.checked; }).map(function (x) { return BUCKETS[+x.getAttribute('data-price')]; });
          if (!sel.length) state.price = [null, null];
          else {
            var lo = sel.some(function (b) { return !b[0]; }) ? '' : String(Math.min.apply(null, sel.map(function (b) { return +b[0]; })));
            var hi = sel.some(function (b) { return !b[1]; }) ? '' : String(Math.max.apply(null, sel.map(function (b) { return +b[1]; })));
            state.price = [lo || null, hi || null];
          }
          state.page = 1; sync(); load(false);
        });
      });
      $('mobile-count').textContent = t('show_n', 'Toon {n} producten').replace('{n}', $('count').textContent.split(' ')[0]);
    }
    function renderActive() {
      var chips = [];
      Object.keys(state.filters).forEach(function (f) { (state.filters[f] || []).forEach(function (v) { chips.push({ f: f, v: v, label: v }); }); });
      if (state.price[0] || state.price[1]) chips.push({ f: 'price', v: '', label: bucketLabel([state.price[0] || '', state.price[1] || '']) });
      var box = $('active'); box.innerHTML = chips.map(function (c) { return '<button type="button" class="kbr-chip" data-f="' + c.f + '" data-v="' + esc(c.v) + '">' + esc(c.label) + ' <span aria-hidden="true">×</span></button>'; }).join('');
      box.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () {
        var f = b.getAttribute('data-f'); if (f === 'price') state.price = [null, null]; else state.filters[f] = state.filters[f].filter(function (x) { return x !== b.getAttribute('data-v'); });
        state.page = 1; sync(); load(false);
      }); });
      $('filter-label').textContent = t('filters', 'Filters') + (chips.length ? ' (' + chips.length + ')' : '');
    }
    function clearAll() { state.filters = {}; state.price = [null, null]; state.page = 1; sync(); load(false); }
    function sync() {
      var u = new URLSearchParams({ q: state.q });
      if (state.sort !== 'relevance') u.set('sort', state.sort);
      Object.keys(state.filters).forEach(function (f) { if (state.filters[f].length) u.set(f, state.filters[f].join(',')); });
      if (state.price[0]) u.set('price_min', state.price[0]); if (state.price[1]) u.set('price_max', state.price[1]);
      history.replaceState(null, '', location.pathname + '?' + u.toString());
    }
    $('sort').value = state.sort;
    $('sort').addEventListener('change', function () { state.sort = $('sort').value; state.page = 1; sync(); load(false); });
    $('more').addEventListener('click', function () { state.page++; load(true); });
    var sheet = $('sheet');
    $('filter-toggle').addEventListener('click', function () { sheet.classList.add('open'); });
    $('sheet-close').addEventListener('click', function () { sheet.classList.remove('open'); });
    $('backdrop').addEventListener('click', function () { sheet.classList.remove('open'); });
    $('mobile-count').addEventListener('click', function () { sheet.classList.remove('open'); });
    $('sheet-clear').addEventListener('click', clearAll);
    $('clear-filters').addEventListener('click', clearAll);
    load(false); // ook zonder zoekterm: alle producten, gesorteerd en filterbaar
  }
})();
